module.exports = __webpack_public_path__ + "img/80a85adcc9574b1918297bfc9e37186b.3aa9c009.jpg";